const Loader = () => (
  <div className="flex justify-center items-center py-3 ldr">
    <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-white" />
  </div>
);

export default Loader;
